module.exports = __webpack_public_path__ + "img/epanouissement@2x.1b552002.png";